import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize, timer, map, forkJoin } from 'rxjs';
import { LoadingService } from '../../services/shared/loader/loading.service';
import { environment } from '@orderna/admin-panel/src/environments/environment';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.api)) {
    return next(req);
  }

  const loadingService = inject(LoadingService);

  const base = environment.api.endsWith('/')
    ? environment.api
    : environment.api + '/';
  const relativeUrl = req.url.replace(base, '');
  const key = `${req.method} ${relativeUrl}`;
  loadingService.start(key);

  return forkJoin([next(req), timer(300)]).pipe(
    map(([response]) => response),
    finalize(() => loadingService.finish(key))
  );
};
